//Sidebar
import styled from "styled-components";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { FiUsers, FiBarChart2, FiCloud } from "react-icons/fi";
import { MdReceiptLong } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export const Sidebar = ({ open = false, onClose }) => {
  const navigate = useNavigate();
  const { permissionLevel } = useContext(AuthContext);

  return (
    <>
      <Container open={open}>
        <LogoWrapper>
          <Logo style={{ width: "80%" }} src="/alterdata_logo.png" alt="Logo" />
          <AppName>Sistema de Backups</AppName>
        </LogoWrapper>

        <Nav>
          <NavItem onClick={() => navigate("/dashboard")}>
            <FiBarChart2 />
            <span>Painel</span>
          </NavItem>

          {(permissionLevel !== 1 && permissionLevel !== 2) && (
            <NavItem onClick={() => navigate("/backups")}>
              <FiCloud />
              <span>Meus Backups</span>
            </NavItem>
          )}

          {/* Só mostra o menu 'Usuários' para PERMISSION_LEVEL 1 e 2 */}
          {(permissionLevel === 1 || permissionLevel === 2) && (
            <NavItem onClick={() => navigate("/usuarios")}>
              <FiUsers />
              <span>Usuários</span>
            </NavItem>
          )}

          {/* Todos podem ver boletos, exceto se quiser restringir mais */}
          {(permissionLevel !== 1 && permissionLevel !== 2) && (
            <NavItem onClick={() => navigate("/fatura")}>
              <MdReceiptLong />
              <span>Boletos</span>
            </NavItem>
          )}
        </Nav>
      </Container>
      <Overlay open={open} onClick={onClose} />
    </>
  );
};

// Estilo
// Sidebar.js
const Container = styled.aside`
  position: fixed;
  top: 60px;
  left: 0;
  width: 240px;
  height: calc(100dvh - 60px);
  background: #111;
  color: #fff;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #2e2e2e;
  overflow-y: auto;
  z-index: 1050; /* acima do overlay, abaixo do header */
  transition: transform 0.25s ease;
  will-change: transform;

  /* Desktop: sempre visível */
  transform: translateX(0);

  /* Mobile: drawer que entra/saí */
  @media (max-width: 760px) {
    width: min(85vw, 280px);
    transform: translateX(${({ open }) => (open ? "0" : "-100%")});
    box-shadow: ${({ open }) => (open ? "0 10px 30px rgba(0,0,0,.4)" : "none")};
  }
`;

const Overlay = styled.div`
  display: none;
  @media (max-width: 760px) {
    display: ${({ open }) => (open ? "block" : "none")};
    position: fixed;
    inset: 60px 0 0 0; /* abaixo do header */
    background: rgba(0, 0, 0, 0.45);
    z-index: 1000; /* abaixo do Container (1050) */
  }
`;

const LogoWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const Logo = styled.img`
  width: 80px;
  margin-bottom: 0.5rem;
`;

const AppName = styled.div`
  font-size: 1rem;
  font-weight: bold;
  color: #ccc;
`;

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.7rem 1rem;
  border-radius: 8px;
  color: #ccc;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #2b2b2b;
  }

  svg {
    font-size: 1.2rem;
  }

  span {
    font-size: 1rem;
  }
`;
